var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecipitationChangeJunJulAug({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url('/?mapBounds=-151.6430826,-76.539079,208.0053549,81.0784081&mapStyle=Light&activeLocation=-31.4351977,24.1381674&activeLayers=GEOPORTAL_SHARED:Surge#clip0_16392_109338')"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.141 6 3.04 3.245V7.968c0-.474.506-.71 1.52-.71.944 0 1.463.206 1.555.618l.013.092v4.344l.997.935c.49.362.734.85.734 1.465 0 .553-.126.937-.378 1.153l-.09.066H19.27l.001 2.779A9.37 9.37 0 0 0 22 17.564v2.817C20.131 21.461 18.057 22 15.777 22c-3.42 0-4.791-2.182-8.628-2.182-2.559 0-4.275.35-5.149 1.052v-2.817C2.913 17.35 4.608 17 7.083 17c.242 0 .473.009.695.026l-.003-1.095h-1.01c-.407 0-.765-.428-.765-1.22 0-.435.115-.783.346-1.042l.106-.106L13.14 6ZM15 16.5h-2a1 1 0 0 0-.993.883L12 17.5v.804c1.056.431 2.189.804 3.777.804l.223-.004V17.5a1 1 0 0 0-1-1ZM4.5 8S6 9.612 6 10.567C6 11.358 5.328 12 4.5 12S3 11.358 3 10.567C3 9.612 4.5 8 4.5 8Zm4-4S10 5.612 10 6.567C10 7.36 9.328 8 8.5 8S7 7.359 7 6.567C7 5.612 8.5 4 8.5 4Zm-5-2S5 3.612 5 4.567C5 5.36 4.328 6 3.5 6S2 5.359 2 4.567C2 3.612 3.5 2 3.5 2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 7,
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.784 14.225 17.5 12l-1.369 2.37-2.835-.76.73 2.72L12 17.5l2.025 1.17-.729 2.72 2.835-.76L17.5 23l1.284-2.225 2.29.614-.644-2.405L23 17.5l-2.57-1.484.645-2.405-2.29.614ZM17.5 19.333a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16392_109338"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecipitationChangeJunJulAug);
export default __webpack_public_path__ + "static/media/precipitation_change_jun_jul_aug.f5ba44fe694a34a1cea1ba5df1d228f5.svg";
export { ForwardRef as ReactComponent };